export const datepickerInputMask: Array<string | RegExp> = [/[0-3]/, /\d/, '.', /[0-1]/, /\d/, '.',  /[1-2]/, /\d/, /\d/, /\d/];
